import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppUseDispatch, AppUseSelector } from '../../../redux/hooks'
import { SET_GOAL } from '../../../redux/types'
import { trackOnboarding } from '../../../utils/analytics'
import { Glyph } from './icons'
import { StepTitle, StepSubtitle, useLanguageName } from '../stepContext'

// Each goal is marked by a single character on a seal-like tile — the
// learner meets real Chinese from the very first screen. `label` and `hint`
// are translation keys.
export const GOAL_OPTIONS = [
  { key: 'travel', glyph: '旅', label: 'onboarding:goal.options.travel.label', hint: 'onboarding:goal.options.travel.hint' },
  { key: 'work', glyph: '商', label: 'onboarding:goal.options.work.label', hint: 'onboarding:goal.options.work.hint' },
  { key: 'family', glyph: '家', label: 'onboarding:goal.options.family.label', hint: 'onboarding:goal.options.family.hint' },
  { key: 'exams', glyph: '考', label: 'onboarding:goal.options.exams.label', hint: 'onboarding:goal.options.exams.hint' },
  {
    key: 'culture',
    glyph: '文',
    label: 'onboarding:goal.options.culture.label',
    hint: 'onboarding:goal.options.culture.hint',
  },
  {
    key: 'challenge',
    glyph: '智',
    label: 'onboarding:goal.options.challenge.label',
    hint: 'onboarding:goal.options.challenge.hint',
  },
]

const GoalStep = ({ next }: { next: () => void }) => {
  const { t } = useTranslation('onboarding')
  const dispatch = AppUseDispatch()
  const { goal, languageInfo } = AppUseSelector(({ onboarding }) => onboarding)
  const languageName = useLanguageName(languageInfo?.language)

  const selectGoal = (key: string) => {
    dispatch({ type: SET_GOAL, payload: key })
    trackOnboarding('goal_selected', { goal: key })
    next()
  }

  return (
    <div className='ob-step'>
      <StepTitle>{t('goal.title', { language: languageName })}</StepTitle>
      <StepSubtitle>{t('goal.subtitle')}</StepSubtitle>
      <div className='ob-options ob-options--2col'>
        {GOAL_OPTIONS.map((option) => (
          <button
            key={option.key}
            type='button'
            className={`ob-option ${goal === option.key ? 'is-selected' : ''}`}
            onClick={() => selectGoal(option.key)}
          >
            <Glyph char={option.glyph} />
            <span className='ob-option-body'>
              {t(option.label)}
              <span className='ob-option-hint'>{t(option.hint)}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default GoalStep
